import React from "react";

import * as S from "./styles";

export const Slide14: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Content>
          <S.Photo />
        </S.Content>
        <S.Staff>
          Coordenação de moda: <span>André Puertas</span>
          <br />
          Tratamento de imagem: <span>Thiago Auge</span>
          <br />
          Produção executiva: <span>Isabela de Paula</span>
        </S.Staff>
      </S.Wrapper>
    </S.Container>
  );
};
